export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5625.ccdfcc82.jpg";